// Sidebar sticky when scrolling

import StickySidebar from 'sticky-sidebar';
import { debounce } from 'js-utils/src/function';
import { getElements } from 'js-utils/src/selector';
import { addEventListener } from 'js-utils/src/event';

import init from '../../common/base/init';

init(() => {
  const sidebarSelector = '.layout-main__aside';
  let sidebar = document.querySelector(sidebarSelector);
  if(!sidebar) return;

  let fixedHeader = document.querySelector('.header--fixed');
  let topSpacing = fixedHeader ? 100 : 73;

  let Sticky = null;
  const stickyMQ = '(min-width: 60.0625em)'; // 'large' in SASS
  const stickyConfig = {
    topSpacing: topSpacing,
    bottomSpacing: 20,
    minWidth: 640,
  };

  const toggleSticky = () => {
    if(window.matchMedia(stickyMQ).matches) {
      if(!Sticky) {
        Sticky = new StickySidebar(sidebarSelector, stickyConfig);
      }
    }
    else {
      if(Sticky) {
        Sticky.destroy();
        Sticky = null;
      }
    }
  };

  toggleSticky();
  window.addEventListener('resize', debounce(300, toggleSticky));

  addEventListener(getElements('.toggle', sidebar), 'click', () => {
    if(Sticky) {
      Sticky.updateSticky();
    }
  });
});
